import { IconPlus, Tooltip } from '@issuu/silkscreen';
import React, { useContext, useRef, useState } from 'react';

import DocumentContext from '../DocumentPage/DocumentContext';
import { checkLogin } from '../shared/check-login';
import { ActionButton, ActionIcon } from './ActionButton';
import { DocumentSaveModal } from './DocumentSaveModal';

const Save: React.FC = () => {
    const {
        visitor: { isLoggedIn },
    } = useContext(DocumentContext);
    const [isSaveModalShowing, setIsSaveModalShowing] = useState<boolean>(false);
    const buttonRef = useRef<HTMLButtonElement>(null);
    return (
        <>
            <Tooltip id="save_tooltip" size="medium" text="Save the publication to a stack">
                <ActionButton
                    aria-describedby="save_tooltip"
                    onClick={() =>
                        checkLogin(isLoggedIn, () => {
                            setIsSaveModalShowing(true);
                        })
                    }
                    ref={buttonRef}
                >
                    <ActionIcon>
                        <IconPlus />
                    </ActionIcon>
                    Save
                </ActionButton>
            </Tooltip>
            <DocumentSaveModal
                isOpen={isSaveModalShowing}
                onClose={() => {
                    setIsSaveModalShowing(false);
                    buttonRef.current?.focus();
                }}
            />
        </>
    );
};

export default Save;
